import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { DatePicker } from 'antd';
import moment from 'moment';
import $ from 'jquery';

import 'antd/dist/antd.css';

const { RangePicker } = DatePicker;

export default class OrganisationFilters extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
		$(document).click(function(e) {
		  var container = $('.organisation-filters-container > .organisation-filters > .filter-container');
		  $(container).each(function() {
		    if($(e.target).parents('.filter-container')[0] === $(this)[0]) {
		    	// Clicked inside container
		    } else $(this).find('.filter-dropdown').addClass('hidden');
		  });
		});
	}

	showDropdown(target) {
		$(target).siblings('.filter-dropdown').removeClass('hidden');
	}

	render() {
		return (
			<div className="organisation-filters-container">
				<div className="organisation-filters">
					<div className="on-trial-filter-container filter-container">
						<span className="filter-span" onClick={(e) => this.showDropdown(e.target)}>On Trial <i className="fa fa-chevron-down"></i></span>
						{this.props.filters.trial !== null ? (
							this.props.filters.trial ? (<span className="show-filter-value">( Yes )</span>) : (<span className="show-filter-value">( No )</span>)
						) : (null)}
						<div className="on-trial-dropdown filter-dropdown hidden">
							<div>
								<input type="radio" name="on-trial" checked={this.props.filters.trial}
									onChange={() => this.props.changeTrial(true)} /> Yes
							</div>
							<div>
								<input type="radio" name="on-trial" onChange={() => this.props.changeTrial(false)}
								checked={this.props.filters.trial !== null && !this.props.filters.trial} /> No
							</div>
							{/*<div className="filter-apply-clear">
								<i className="fa fa-times"></i>
							</div>*/}
						</div>
					</div>

					<div className="renewal-date-filter-container filter-container">
						<span className="filter-span" onClick={(e) => this.showDropdown(e.target)}>Renewal Date <i className="fa fa-chevron-down"></i></span>
						{this.props.filters.fromDate !== null && this.props.filters.toDate !== null ? (
							<span className="show-filter-value">
								{'( ' + moment(this.props.filters.fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY') + ' - ' + moment(this.props.filters.toDate, 'YYYY-MM-DD').format('DD-MM-YYYY') + ' )'}
							</span>
						) : (null)}
						<div className="renewal-date-dropdown filter-dropdown hidden">
							<div>
								<RangePicker onChange={this.props.changeDate} value={[this.props.filters.fromDate, this.props.filters.toDate]}/>
							</div>
						</div>
					</div>

					<div className="published-filter-container filter-container">
						<span className="filter-span" onClick={(e) => this.showDropdown(e.target)}>Published <i className="fa fa-chevron-down"></i></span>
						{this.props.filters.published !== null ? (
							this.props.filters.published ? (<span className="show-filter-value">( Yes )</span>) : (<span className="show-filter-value">( No )</span>)
						) : (null)}
						<div className="published-dropdown filter-dropdown hidden">
							<div>
								<input type="radio" name="published" checked={this.props.filters.published}
									onChange={() => this.props.changePublished(true)} /> Yes
							</div>
							<div>
								<input type="radio" name="published" onChange={() => this.props.changePublished(false)}
									checked={this.props.filters.published !== null && !this.props.filters.published} /> No
							</div>
						</div>
					</div>

					<div className="domain-filter-container filter-container">
						<span className="filter-span" onClick={(e) => this.showDropdown(e.target)}>Has Domain <i className="fa fa-chevron-down"></i></span>
						{this.props.filters.domain !== null ? (
							this.props.filters.domain ? (<span className="show-filter-value">( Yes )</span>) : (<span className="show-filter-value">( No )</span>)
						) : (null)}
						<div className="domain-dropdown filter-dropdown hidden">
							<div>
								<input type="radio" name="domain" checked={this.props.filters.domain}
									onChange={() => this.props.changeHasDomain(true)} /> Yes
							</div>
							<div>
								<input type="radio" name="domain" onChange={() => this.props.changeHasDomain(false)}
									checked={this.props.filters.domain !== null && !this.props.filters.domain} /> No
							</div>
						</div>
					</div>

					<div className="period-filter-container filter-container">
						<span className="filter-span" onClick={(e) => this.showDropdown(e.target)}>Subscription Period <i className="fa fa-chevron-down"></i></span>
						{this.props.filters.paid_for !== null ? (
							<span className="show-filter-value">{'( ' + this.props.filters.paid_for + ' )'}</span>
						) : (null)}
						<div className="period-dropdown filter-dropdown hidden">
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '1 Month'}
									onChange={() => this.props.changePeriod('1 Month')} /> 1 Month
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '6 Months'}
									onChange={() => this.props.changePeriod('6 Months')} /> 6 Months
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '1 Year'}
									onChange={() => this.props.changePeriod('1 Year')} /> 1 Year
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '2 Years'}
									onChange={() => this.props.changePeriod('2 Years')} /> 2 Years
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '3 Years'}
									onChange={() => this.props.changePeriod('3 Years')} /> 3 Years
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === '5 Years'}
									onChange={() => this.props.changePeriod('5 Years')} /> 5 Years
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === 'Trial'}
									onChange={() => this.props.changePeriod('Trial')} /> Trial
							</div>
							<div>
								<input type="radio" name="period" checked={this.props.filters.paid_for === 'Partial'}
									onChange={() => this.props.changePeriod('Partial')} /> Partial
							</div>
						</div>
					</div>
				</div>

				<div className="organisation-filters-reset">
					<span className="filter-reset-span" onClick={this.props.resetFilters}>Reset</span>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/ManageSwayam/OrganisationFilters.js